export class OfferModel {
  statusOffer: boolean;
  id: number;
  product: string;
  offerType: string;
  destination: string;
  amount: string;
  amountMaximum: string;
  variableIncome: string;
  monthlyFee: string;
  riskLevel: string;
  maxTermFreeInvestment: number;
  rate: {
    rate_MV: string;
    rate_EA: string;
    rate_NA: string;
  } = {
    rate_MV: '',
    rate_EA: '',
    rate_NA: '',
  };
  expiredOffer: Date;
  constructor(offer: { offer_id: number; product_info: { product_id: string; }; end_date: Date; offer_amount: { amount: string; }; offer_parameters: any; }) {
    this.id = offer.offer_id;
    this.expiredOffer = offer.end_date;
    this.amount = offer.offer_amount.amount;
    this.amountMaximum = this.amount;

    const params = offer.offer_parameters;
    this.product = params.find((p: { key: string; }) => p.key == 'product').name;
    this.offerType = params.find((p: { key: string; }) => p.key == 'offer_type').name;
    this.destination = params.find((p: { key: string; }) => p.key == 'destination').name;

    this.variableIncome = params.find((p: { key: string; }) => p.key == 'variable_income').name;
    this.monthlyFee = params.find((p: { key: string; }) => p.key == 'monthly_fee').name;
    this.riskLevel = params.find((p: { key: string; }) => p.key == 'risk_level').name;
    this.maxTermFreeInvestment = params.find((p: { key: string; }) => p.key == 'max_term_free_investment').name;
    this.rate.rate_MV = params.find((p: { key: string; }) => p.key == 'rate_mv').name;
    this.rate.rate_EA = params.find((p: { key: string; }) => p.key == 'rate_ea').name;
    this.rate.rate_NA = params.find((p: { key: string; }) => p.key == 'rate_na').name;
  }
}
